var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEthereum(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group-45"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Oval",
    d: "M6.59033 12.763C9.90404 12.763 12.5903 10.0767 12.5903 6.76297C12.5903 3.44926 9.90404 0.76297 6.59033 0.76297C3.27662 0.76297 0.590332 3.44926 0.590332 6.76297C0.590332 10.0767 3.27662 12.763 6.59033 12.763Z",
    fill: "#627EEA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M6.7771 2.26215V5.58855L9.58847 6.84498L6.7771 2.26215Z",
    fill: "white",
    fillOpacity: 0.602
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1_",
    d: "M6.77719 2.26215L3.96582 6.84498L6.77719 5.58855V2.26215Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2_",
    d: "M6.7771 9.00026V11.2605L9.59011 7.36823L6.7771 9.00026Z",
    fill: "white",
    fillOpacity: 0.602
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3_",
    d: "M6.77719 11.2605V9.00026L3.96582 7.36823L6.77719 11.2605Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4_",
    d: "M6.7771 8.47703L9.58847 6.84499L6.7771 5.58856V8.47703Z",
    fill: "white",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5_",
    d: "M3.96582 6.84499L6.77719 8.47703V5.58856L3.96582 6.84499Z",
    fill: "white",
    fillOpacity: 0.602
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEthereum);
export default __webpack_public_path__ + "static/media/ethereum.270d98961abcd0ae4e5a19bb90c7ec68.svg";
export { ForwardRef as ReactComponent };